import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import {ComponentPropsFromRoute} from "../../../routers/routers";
import {Button, Space, Typography} from "antd";
import {Claim, ClaimStatus} from "../../../models/claims/claims";
import {claimService} from "../../../services/claims/claims.service";
import {useParams} from "react-router-dom";
import {LoadingSpin} from "../../common/loading-spin/loading.spin";
import {ClaimsStatus} from "../status/claim.status";
import {ClaimComments} from "./comments/claim.comments";
import {ClaimParts} from "./parts/claim.parts";
import {ClaimDescription} from "./descrption/claim.description";
import {notifications} from "../../../services/notifications/notifications";
import {useTranslate} from "../../../hooks/translate.hook";
import {PageHeader} from "@ant-design/pro-components";
import {downloadBlobFile} from "../../../utils/blob.download";

export const ClaimView: React.FC<ComponentPropsFromRoute> = observer(({name}) => {

    const { id } = useParams<{ id: string }>();
    const t = useTranslate();

    const [claim, setClaim] = useState<Claim>();
    const [updateState, setUpdateState] = useState<boolean>(false);

    const update = async () => {
        setUpdateState(true);
        setClaim(undefined);
        await claimService.getClaim(parseInt(id!)).then(claim => setClaim(claim));
        setUpdateState(false);
    }

    const download = async () => {
        const {blob, filename} = await claimService.downloadClaim(parseInt(id!));
        downloadBlobFile(blob, filename)
    }

    const finishProcessing = async () => {
        await claimService.complete(claim!.id);
        await update();
        notifications.successfully();
    }

    const close = async () => {
        await claimService.close(claim!.id);
        await update();
        notifications.successfully();
    }

    useEffect(() => {
        update();
    }, [])

    if (!claim) {
        return <LoadingSpin />
    }

    return (
        <Space direction="vertical" size={[20, 20]}>
            <PageHeader
                style={{ padding: 0 }}
                ghost={false}
                title={
                    <Typography.Title level={1} style={{ margin: 0 }}>
                        {t("CLAIMS.CLAIM.TITLE") + " #" + claim.documentNumber}
                    </Typography.Title>
                }
                subTitle={
                    <Typography.Text disabled>
                        {t("CLAIMS.CLAIM.TYPE." + claim.type.toUpperCase())}
                    </Typography.Text>
                }
                extra={<ClaimsStatus large status={claim.status} />}
            >
                <Space direction={"horizontal"}>
                    {claim.status === ClaimStatus.RECEIVED ? (
                        <Button type={"primary"} onClick={finishProcessing}>{t('CLAIM.ACTION.TO_AWAITING_RETURN')}</Button>
                    ) : null}
                    {claim.status === ClaimStatus.AWAITING_RETURN || claim.status === ClaimStatus.RECEIVED ? (
                        <Button type={"primary"} onClick={close}>{t('CLAIM.ACTION.TO_CLOSED')}</Button>
                    ) : null}
                    <Button type={"default"} onClick={download}>{t('DOWNLOAD.DO_DOWNLOAD')}</Button>
                </Space>
            </PageHeader>

            <ClaimDescription claim={claim} />
            <ClaimComments claim={claim} />
            {claim ? (
                <ClaimParts claim={claim} onUpdate={update} loading={updateState} />
            ) : (
                <LoadingSpin />
            )}
        </Space>
    );
});
